export default {
	valuePlus: 1,
	funSource: 2,
	pulse: 3,
	essentialsForHome: 9,
	homePlay: 15,
	valueAccess: 17,
	saversSolution: 57,
	valueSource: 71,
	budgetSource: 75,
	tasteForSavings: 79,
	buyersPlus: 143,
	savingsCentral: 147,
	giftCardConnection: 282,
	rizzbates: 308
};
